import {useEffect, useId, useRef, useState} from 'react';
import {createPortal} from 'react-dom';
import Icon from './Icon';

// Keep optional reading outside the phone's fixed-height planning frame.
export default function PlannerDetails({className, label, summary, mobileSummary, children}) {
  const [phone, setPhone] = useState(() => window.matchMedia?.('(max-width: 759px)').matches ?? false);
  const dialog = useRef(null);
  const titleId = useId();
  useEffect(() => {
    const media = window.matchMedia?.('(max-width: 759px)');
    if (!media) return;
    const update = () => { dialog.current?.close(); setPhone(media.matches); };
    media.addEventListener('change', update);
    return () => media.removeEventListener('change', update);
  }, []);
  if (!phone) return <details className={className}><summary aria-label={label}>{summary}</summary>{children}</details>;
  return <>
    <div className={className}><button type="button" className="qgp-details-trigger" aria-label={label} aria-haspopup="dialog" onClick={() => dialog.current.showModal()}>{mobileSummary || summary}</button></div>
    {createPortal(<dialog ref={dialog} className="qgp-reading-dialog" aria-labelledby={titleId} dir="rtl" onClick={event => {if (event.target === event.currentTarget) dialog.current.close();}}>
      <header><h3 id={titleId}>{label}</h3><button type="button" autoFocus aria-label="بستن جزئیات" onClick={() => dialog.current.close()}><Icon name="close" size={20}/></button></header>
      <div className="qgp-reading-dialog__body">{children}</div>
      <form method="dialog"><button>متوجه شدم</button></form>
    </dialog>, document.body)}
  </>;
}
